import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDividerModule } from "@angular/material/divider";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { TranslateModule } from "@ngx-translate/core";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";

import { IauiLoginBettingLimitModalComponent } from "./iaui-login-betting-limit-modal.component";
import { IauiLoginBettingLimitComponent } from "./iaui-login-betting-limit.component";

@NgModule({
	imports: [
		CoreModule,
		CoreUiModule,
		CommonModule,
		MatDividerModule,
		MatButtonModule,
		MatFormFieldModule,
		MatRadioModule,
		MatInputModule,
		ReactiveFormsModule,
		DialogLayoutModule,
		TranslateModule,
	],
	exports: [IauiLoginBettingLimitModalComponent, IauiLoginBettingLimitComponent],
	declarations: [IauiLoginBettingLimitModalComponent, IauiLoginBettingLimitComponent],
})
export class IauiBettingLimitModule {
	constructor(resolver: ComponentFactoryResolver, componentFactoryService: ComponentFactoryService) {
		componentFactoryService.registerLazyLoadedResolver(resolver, IauiLoginBettingLimitModalComponent);
	}
}
